const UploadPropertyPageStyles = {
    pageContainer: {
        padding: '2rem',
        maxWidth: '800px',
        margin: 'auto',
        backgroundColor: '#f9f9f9',
        borderRadius: '10px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    },
    pageTitle: {
        fontWeight: 'bold',
        marginBottom: '2rem',
        textAlign: 'center',
        color: '#333',
    },
    textField: {
        marginBottom: '1rem',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
        },
    },
    selectContainer: {
        marginBottom: '1rem',
    },
    uploadButton: {
        marginBottom: '1rem',
        fontWeight: 'bold',
        padding: '10px 20px',
        backgroundColor: '#81c241"'
    },
    previewContainer: {
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
    },
    imagePreview: {
        width: '100px',
        height: '100px',
        overflow: 'hidden',
        borderRadius: '8px',
        border: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
    },
    submitButton: {
        marginTop: '1rem',
        padding: '0.75rem',
        fontWeight: 'bold',
        borderRadius: '8px',
        backgroundColor: '#81c241"'
    },
};

// Custom styles for react-select dropdowns
const selectStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: '8px',
        minHeight: '56px',
        borderColor: '#ddd',
        boxShadow: 'none',
        '&:hover': { borderColor: '#aaa' },
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Ensure dropdown appears above other elements
        borderRadius: '8px',
        marginTop: 0,
        boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0,
        borderRadius: '8px',
    }),
};

export { UploadPropertyPageStyles, selectStyles };

